export default "__VITE_ASSET__BFTT6UMA__"